document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  // Initialize Lenis smooth scroll
  var lenis = new Lenis({
    duration: 1.2,
    easing: function(t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    smoothTouch: false,
  });

  // Expose globally so other scripts can use lenis.scrollTo()
  window.lenis = lenis;

  // Sync Lenis with GSAP ScrollTrigger
  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add(function(time) {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  // Handle all anchor links via Lenis
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target);
      }
    });
  });

  // Footer logo 3D flip-in on scroll
  var footerLogo = document.querySelector('footer .footer-logo');
  if (footerLogo) {
    gsap.set(footerLogo, { rotationY: 1080, opacity: 0, xPercent: 50, transformPerspective: 800 });

    gsap.to(footerLogo, {
      rotationY: 0,
      xPercent: 0,
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: footerLogo,
        start: 'top 100%',
        end: 'bottom 100%',
        scrub: 1,
      },
    });
  }

});
